@if (isDataChanged) {
  <div class="save">
    <button (click)="saveWorksheet()" mat-raised-button color="primary">
      SAVE
    </button>
  </div>
}

<section class="precast-tabel-container" [ngClass]="{'with-save-button': isDataChanged}">
  @if (dataSource) {
    <mat-table
      #table
      [dataSource]="dataSource"
      aria-describedby="listOfWorksheets"
      cdkDropList
      [cdkDropListDisabled]="dragDisabled"
      (cdkDropListDropped)="onDrop($event)"
      >
      <!-- Header Row -->
      <mat-header-row
        *matHeaderRowDef="displayedColumns.concat('action', 'sort'); sticky: true">
      </mat-header-row>
      <!-- Data Row -->
      <mat-row
        *matRowDef="let row; let i = index; columns: displayedColumns.concat('action', 'sort');"
        [class.gray-zebra]="row.sequence % 2 !== 0"
        [class.bold-bottom-border]="isLastRowOfSample(row, i)"
        cdkDrag
        [cdkDragDisabled]="row.groupOrder !== 0"
        [cdkDragData]="row">
      </mat-row>
      <!-- Dynamic Columns -->
      @for (columnName of displayedColumns; track columnName) {
        <ng-container [matColumnDef]="columnName">
          <mat-header-cell class="header-text" *matHeaderCellDef [matTooltip]="getTooltipText(columnName)">
            @if (columnName === 'select' && roleCheck(['Admin','Manager'])) {
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="masterToggle()"
                [checked]="isAllSelected()"
                [indeterminate]="isIndeterminate()">
              </mat-checkbox>
            } @else {
              <span [innerHTML]="getDisplayName(columnName)"></span>
            }
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="row-cell" [attr.rowspan]="getSpan(row, columnName)">
            <!-- Wrap content inside a div to hide only data, not the cell -->
            <div [style.visibility]="isHidden(row, columnName) ? 'hidden' : 'visible'">
              <!-- Select Column -->
              @if (columnName === 'select' && roleCheck(['Admin','Manager']) && isParentRow(row)) {
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="toggleSelection(row);"
                  [checked]="selection.selected.includes(row)">
                </mat-checkbox>
              }
              <!-- Sample ID Column -->
              @if (columnName === 'sampleId') {
                <div class="sampleid">
                  <span class="truncate-label-2line col-width-100 sp" [attr.title]="row.sampleId">
                    {{ row.sampleId | truncate : 57 }}
                  </span>
                  @if (row?.truckNumber) {
                    <span
                      class="truncate-label-2line col-width-100 sp"
                      #tooltip="matTooltip"
                      [matTooltip]="row.truckNumber">
                      Truck# {{ row?.truckNumber }}
                    </span>
                  }
                  @if (row?.ticketNumber) {
                    <span
                      class="truncate-label-2line col-width-100 sp"
                      #tooltip="matTooltip"
                      [matTooltip]="row.ticketNumber">
                      Ticket# {{ row?.ticketNumber }}
                    </span>
                  }
                </div>
              }
              <!-- Mix Design Code Column -->
              @if (columnName === 'mixDesignCode') {
                <a href="javascript:void(0)" class="mix-link" (click)="onMixDesignClick(row)">
                  {{ row.mixDesignCode }}
                </a>
              }
              <!-- Group Order Column -->
              @if (columnName === 'groupOrder') {
                {{ row.groupOrder ? row.groupOrder + 1 : 1 }}
              }
              <!-- Status Column -->
              @if (columnName === 'status') {
                @if (row.status) {
                  <img alt="check" src="../../../../assets/icons/Check.svg" />
                }
                @if (!row.status) {
                  <img alt="icon" src="../../../../assets/icons/table icon.svg" />
                }
              }
              <!-- Default Column -->
              @if (columnName !== 'status' && columnName !== 'sampleId' && columnName !== 'groupOrder' && columnName !== 'mixDesignCode') {
                <span #tooltip="matTooltip"
                  [matTooltip]="getRowDataByKey(row, columnName)"
                  >
                  {{ getRowDataByKey(row, columnName) }}
                </span>
              }
            </div>
          </mat-cell>
        </ng-container>
      }
      <!-- Action Column -->
      <ng-container matColumnDef="action" stickyEnd>
        <mat-header-cell class="header-text" *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let row">
          @if (roleCheck(['Manager', 'Labtech', 'Admin']) && !row.groupOrder) {
            <button mat-icon-button [matMenuTriggerFor]="menu"
              >
              <mat-icon>more_vert</mat-icon>
            </button>
          }
          <mat-menu class="dashboard-menu" #menu="matMenu" yPosition="below" xPosition="after">
            <button mat-menu-item (click)="openAssignToDialog(row)">
              <span class="menu-text">
                <img src="/assets/icons/User-multiple.svg" alt="File" /> &nbsp; Assign To
              </span>
            </button>
            @if (!checkEnableOpentTechWorkSheet && roleCheck(['Manager', 'Admin']) && !isMultipleSelected(row)) {
              <button mat-menu-item
                (click)="editWorksheet(row, true)"
                [disabled]="enableOpenTecWorksheet($safeNavigationMigration(row?.status), $safeNavigationMigration(row?.Tech))"
                >
                <span class="menu-text">
                  <img src="/assets/icons/New-window-1.svg" alt="Worksheet" /> &nbsp; Open Tech Worksheet
                </span>
              </button>
            }
            @if (checkEnableOpentTechWorkSheet && roleCheck(['Manager', 'Admin']) && !isMultipleSelected(row)) {
              <button mat-menu-item
                (click)="editWorksheet(row, true)"
                >
                <span class="menu-text">
                  <img src="/assets/icons/New-window-1.svg" alt="Worksheet" /> &nbsp; Open Tech Worksheet
                </span>
              </button>
            }
            @if (roleCheck(['Labtech'])) {
              <button mat-menu-item
                [disabled]="enableOpenTecWorksheetLabTech(row)"
                (click)="editWorksheet(row, false)"
                >
                <span class="menu-text">
                  <img src="/assets/icons/New-window-1.svg" alt="Worksheet" /> &nbsp; Open Tech Worksheet
                </span>
              </button>
            }
            @if (roleCheck(['Manager', 'Admin']) && !isMultipleSelected(row)) {
              <button mat-menu-item (click)="deleteWorksheet(row.id)"
                [disabled]="deleteBtn">
                <span class="menu-text">
                  <img src="/assets/icons/Delete.svg" alt="Delete-icon" /> &nbsp; Delete Row
                </span>
              </button>
            }
          </mat-menu>
        </mat-cell>
      </ng-container>
      <!-- Sort Column -->
      <ng-container matColumnDef="sort" stickyEnd>
        <mat-header-cell class="header-text" *matHeaderCellDef [ngClass]="{'hidden-column': shouldHideSortColumn()}"></mat-header-cell>
        <mat-cell *matCellDef="let row" [ngClass]="{'hidden-column': shouldHideSortColumn()}">
          <div>
            @if (roleCheck(['Manager', 'Admin']) && !row.groupOrder) {
              <button
                (mousedown)="dragDisabled = false;"
                mat-icon-button>
                <mat-icon class="dragCursor">drag_indicator</mat-icon>
              </button>
            }
          </div>
        </mat-cell>
      </ng-container>
    </mat-table>
  }
</section>
